class BrixArtistHero {
  static init(...parameters) {
    return new BrixArtistHero(...parameters);
  }

  // constructor(block) {}
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-artist-hero', BrixArtistHero.init);
}
